import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy: React.FC = () => {
  return (
    <section className="bg-white py-16">
      <div className="max-w-3xl mx-auto px-6">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-2">
          Privacy Policy
        </h1>
        <p className="text-sm text-gray-500 mb-8">
          Last updated: {new Date().toLocaleDateString("en-GB", {
            year: "numeric",
            month: "long",
          })}
        </p>

        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-sm text-yellow-800 mb-8">
          This is a template outlining the platform's actual data practices.
          It has not been reviewed by a solicitor and should be checked
          against UK GDPR / Nigeria Data Protection Act requirements before
          relying on it with real customer data.
        </div>

        <div className="prose prose-sm max-w-none text-gray-700 space-y-6">
          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              What we collect
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Account details: name, email address and phone number.</li>
              <li>
                Phone number verification: your phone number is used to send
                a one-time passcode (via Africa's Talking) when you sign up
                or log in by phone.
              </li>
              <li>
                Location: if you use "Search Near Me", your device's
                location is used to find nearby providers. This is only sent
                when you choose to use that feature.
              </li>
              <li>
                Booking details: service type, address, price and date for
                jobs you book or provide.
              </li>
              <li>
                Payment information: payments are processed by Paystack. We
                do not store your card details ourselves.
              </li>
              <li>
                Reviews: ratings and comments you leave for a provider after
                a completed booking.
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              How we use it
            </h2>
            <p>
              To operate the platform - matching customers with providers,
              processing bookings and payments, sending OTP codes and
              booking notifications, and showing reviews to help other
              customers choose a provider.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              Who we share it with
            </h2>
            <p>
              Paystack (payment processing) and Africa's Talking (SMS/OTP
              delivery) receive the minimum information needed to perform
              those services. Providers you book see the booking and
              contact details needed to complete the job. We don't sell
              your data.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              Your choices
            </h2>
            <p>
              You can update your account details at any time. Location
              access is only requested when you actively use a "near me"
              search, and your browser/device controls whether that's
              granted.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              Contact
            </h2>
            <p>
              Questions about this policy or your data can be sent via our{" "}
              <Link to="/contact" className="text-green-700 hover:underline">
                Contact page
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
